import React from 'react';
import { useSetModalTitle } from './useSetModalTitle';

/**
 * A higher-order function that creates a functional component.
 * It sets the modal title and renders the given component.
 * 
 * Use this HOC to set the modal title when a non functional component 
 * is mounted.
 *
 * @param Component The component to be rendered.
 * @param title The title to be set for the modal.
 * @returns A new functional component that sets the modal title on mount and renders the specified component.
 */
export function withModalTitle<T extends React.JSX.IntrinsicAttributes>(Component: React.ComponentType<T>, title: string): React.FC<T> {
  // Define the wrapped component
  const WrappedComponent: React.FC<T> = (props) => {
    // Use the custom hook to set the modal title
    useSetModalTitle(title);

    // Render the original component with all its props
    return <Component {...props} />;
  };

  // Return the wrapped component
  return WrappedComponent;
}